<template>
	<!-- show-if-above -->
	<q-drawer
		v-if="user"
		v-model="app_state().openDrawerLeft"
		side="left"
		:breakpoint="700"
		:behavior="$_hasTouch ? 'mobile' : 'desktop'"
		:class="'hide-scroll-bar'+($_isDesktop ? ' bg-transparent' : '')"
        :mini="miniDrawer"
        bordered
	>

		<!-- class="full-height"  style="height: calc(100% - 150px); margin-top: 150px; border-right: 1px solid #ddd" -->
		<q-scroll-area
			class="fit q-pb-xl"
			:thumb-style="app_state().scrollarea_bar_style_right">
			<!-- <transition name="slide-fade" duration="600" mode="in-out">
			<div v-show="app_state().openDrawerLeft"> -->

			<q-list separato>
				<!-- <q-item class="bg-primary q-px-sm q-mx-none tops" dense> -->
				<q-item class="q-px-sm q-mx-none" dense>

					<q-item-section side v-if="$_isDesktop">
                        <q-btn @click="miniDrawer = !miniDrawer" flat round dense :icon="miniDrawer ? 'chevron_right' : 'chevron_left'" class=" q-mr--md" />
                    </q-item-section>

					<q-item-section avatar v-if="$_hasTouch" class="q-px-none q-mr--xs" style="min-width: 26px">
						<q-btn icon="close" @click="app_state().openDrawerLeft = false" color="whit" flat round dense />
					</q-item-section>

					<q-item-section class="q-px-none q-mx-none">
						<q-item-label header class="text-whit text-bold ellipsis q-px-sm q-mx-none" style="max-width: 210px">
							<span v-if="$_isDesktop">MENU</span>
							<span v-else>
								{{ utils.infos.societe }}
								<small v-if="utils.infos.slogan" style="font-weight: 200 !important"><br/>{{ utils.infos.slogan }}</small>
							</span>
						</q-item-label>
						<!-- <q-item-label v-if="app_state().count_seconds_without_inactivity" class="text-white bg-secondary text-center q-pa-xs q-animate--fade">
                                <small>{{ pluralize(app_state().count_seconds_without_inactivity,'minute') }}<br>avant déconnexion automatique</small>
                            </q-item-label>
                            <q-item-label v-else class="text-red text-bold bg-grey-3 text-center q-pa-xs q-animate--fade">
                                Déconnecté
                            </q-item-label> -->
					</q-item-section>
					<!-- <q-item-section side>
                            <Popup icon="timer" dense :color="app_state().count_seconds_without_inactivity ? 'info':'red-8'">
                                <small v-if="app_state().count_seconds_without_inactivity"><b>{{ pluralize(app_state().count_seconds_without_inactivity,'minute') }}</b><br>avant déconnexion automatique</small>
                                <small v-else class="text-red-8">Déconnecté, temps d'inactivité maximale écoulé</small>
                            </Popup>
                        </q-item-section> -->

					<q-item-section side class="text-right q-px-none q-mx-xs">
						<!-- FULL SCREEN -->
						<q-btn @click.stop="$q.fullscreen.toggle()" flat round dense
                                :icon="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'"
                                v-if="$q.fullscreen.isCapable" /><!-- && ! $q.platform.is.webkit because ISSUE on Webkit Engine -->
					</q-item-section>
				</q-item>

	<!-- Today Date -->
				<!-- <q-item dense class="bg-secondary text-white q-py-sm" style="border-top: none"> -->
				<q-item dense class="text-whit q-py-sm" style="border-top: none">

					<q-item-section>
						<!-- <q-item-label><b>{{ formatDate({ format: "dddd, D MMMM YYYY" }) }}</b></q-item-label> NON, ça veut pas rester en format FR, en Prod ... !?!?! -->
						<q-item-label>le <b>{{ formatDate({ format: "DD/MM/YYYY" }) }}</b></q-item-label>
					</q-item-section>

					<q-item-section side v-on="timer_logout = app_state().count_minutes_without_inactivity">
						<!-- <q-icon name="today" color="grey-3" size="20px" /> -->
						<!-- :label="!$_isMobile ? 'Connecté' : ''" -->
						<!-- <Popup icon="hourglass_top" size="sm" :color="app_state().count_minutes_without_inactivity > 5 ? 'green-8' : 'orange-8'" dense icon-class="animated delay-10s repeat-3 rotateIn high-slower-2"
							id="guidedtour_drawerleft_count_inactivity">
							<small><b>{{app_state().count_minutes_without_inactivity}} minutes</b><br/>avant déconnexion automatique</small>
						</Popup> -->
                        <q-knob :min="1" :max="pp()?.session_lifetime - 5" readonly
                                v-model="timer_logout"
                                :thickness="0.08" size="32px" track-color="white" center-color="secondary"
                                :color="timer_logout > 15 ? 'positive' : 'warning'"
                                show-value class="q-mt--xs q-mb--xs cursor-pointer text-white"
                                @click="link('')">
                            <!-- <small>{{ timer_logout }}<br/>min.</small>
                            <q-tooltip>{{ timer_logout }} minutes sans activité avant déconnexion automatique<br><small>Cliquez pour réinitialiser</small></q-tooltip> -->
                            <small v-html="minutesToHours(timer_logout)"></small>
                            <q-tooltip><span v-html="minutesToHours(timer_logout, true)"></span> sans activité avant déconnexion automatique<br><small>Cliquez pour réinitialiser</small></q-tooltip>
                        </q-knob>
					</q-item-section>
				</q-item>

	<!-- Master Actions -->
				<WebmasterActions v-if="isMaster" />

	<!-- Dashboard -->
				<q-item
					@click="link(route('dashboard'))"
					clickable
					:active="route().current('dashboard')"
					id="guidedtour_drawerleft_dashboard_link"
				>
					<q-item-section avatar>
						<q-icon name="dashboard" color="grey" />
                        <q-tooltip v-if="miniDrawer">Tableau de Bord</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Tableau de Bord</q-item-label>
					</q-item-section>

					<OpenInNewTab :router="route('dashboard')" />
				</q-item>

				<!-- ADMIN LINKS -->



	<!-- COURSES -->
				<q-item clickable @click="link(route('course.index'))"
                        :active="route().current('course.index')"
                        id="guidedtour_drawerleft_carrier_doc_link">
                         <!-- v-if="isAdmin || isCarrier || isDriver" -->
					<q-item-section avatar>
						<q-icon name="description" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">{{ (isDriver || isClient) ? 'Mes ' : '' }}Courses</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>{{ (isDriver || isClient) ? 'Mes ' : '' }}Courses</q-item-label>
					</q-item-section>
					<q-item-section side>
						<q-btn @click.stop="link(route('course.create')+(route().params?.status ? '?status='+route().params?.status : ''))" v-if=" ! isDriver"
							    icon="add" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_course_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('course.index')" />
				</q-item>

	<!-- RECAP MONTHLY -->
                        <!-- @click="!size_recapMonthlyResult ? courseStore().recapMonthly() : c_state.recapMonthlyOpenModal = !c_state.recapMonthlyOpenModal"
                        :disable="c_state.recapMonthlyOpenModal || (size_recapMonthlyResult && c_state.recapMonthlyOpenModal)" -->
				<q-item clickable :disable="c_state.recapMonthlyOpenModal"
                        @click="c_state.recapMonthlyOpenModal = !c_state.recapMonthlyOpenModal"
                        id="guidedtour_drawerleft_recap_monthly_courses"
                        v-if="(isAdmin || isCarrier)">
					<q-item-section avatar>
						<q-icon name="content_paste_search" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Récapitulatif Mensuel</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Récapitulatif Mensuel</q-item-label>
						<q-item-label caption v-if="size_recapMonthlyResult"><!--  && ! c_state.recapMonthlyOpenModal -->
                            <small>Période {{ c_state.recapMonthlyResult?.period }} en cours...</small>
                        </q-item-label>
					</q-item-section>
					<q-item-section side v-if="size_recapMonthlyResult"><!--  && ! c_state.recapMonthlyOpenModal -->
						<q-btn @click.stop="c_state.recapMonthlyOpenModal = false; c_state.recapMonthlyResult = []"
							    icon="delete_outline" color="warning" flat square size="sm">
                            <q-tooltip>Vider la période en cours</q-tooltip>
                        </q-btn>
					</q-item-section>
				</q-item>

	<!-- Colis -->
				<q-item clickable @click="link(route('colis.index'))"
                        :active="route().current('colis.index')"
                         v-if="isAdmin || isCarrier">
					<q-item-section avatar>
						<q-icon name="inventory_2" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Liste Colis</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Liste Colis</q-item-label>
						<q-item-label caption>par Destinataires</q-item-label>
					</q-item-section>
					<q-item-section side v-if="isClient && !route().current('colis.create')">
						<q-btn @click.stop="link(route('colis.create'))"
							    icon="add" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_colis_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('colis.index')" />
				</q-item>

	<!-- Business -->
                        <!-- :clickable="!isProd || isMaster" -->
				<q-item v-if="isAdmin || isCarrier"
                        clickable
                        @click="link(route('business.index'))"
                        :active="route().current('business.index')">
					<q-item-section avatar>
						<q-icon name="business" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Entreprises Clientes</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Entreprises Clientes</q-item-label>

						<!-- <q-item-label caption v-if="isProd && !isMaster"><small class="text-info">À développer...</small></q-item-label> -->
					</q-item-section>
					<q-item-section side v-if="!route().current('business.create') && isCarrier">
						<q-btn @click.stop="link(route('business.create'))"
							    icon="add" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_business_link_add" /><!--            disable         -->
					</q-item-section>
					<OpenInNewTab :router="route('business.index')"  /><!--             disable          -->
				</q-item>

	<!-- Shops -->
                        <!-- :clickable="!isProd || isMaster" -->
				<q-item v-if="isAdmin || isCarrier"
                        clickable
                        @click="link(route('shop.index'))"
                        :active="route().current('shop.index')">
					<q-item-section avatar>
						<q-icon name="storefront" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Points de Livraison</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Points de Livraison</q-item-label>

						<!-- <q-item-label caption v-if="isProd && !isMaster"><small class="text-info">À développer...</small></q-item-label> -->
					</q-item-section>
					<q-item-section side v-if="!route().current('shop.create') && isCarrier">
						<q-btn @click.stop="link(route('shop.create'))"
							    icon="add" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_shop_link_add" /><!--           disable       -->
					</q-item-section>
					<OpenInNewTab :router="route('shop.index')"  /><!--             disable          -->
				</q-item>



	<!-- Recipients -->
                        <!-- :clickable="!isProd || isMaster" -->
				<!-- <q-item v-if="isAdmin || isCarrier"
                        clickable
                        @click="link(route('recipient.index'))"
                        :active="route().current('recipient.index')">
					<q-item-section avatar>
						<q-icon name="store" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Points de Livraison / Destinataires</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Points de Livraison / Destinataires</q-item-label>
					</q-item-section>
					<q-item-section side v-if="!route().current('recipient.create') && isCarrier">
						<q-btn @click.stop="link(route('recipient.create'))"
							    icon="add" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_recipient_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('recipient.index')"  />
				</q-item> -->

	<!-- Users -->
				<q-item
					clickable
					@click="link(route('users.index'))"
					:active="route().current('users.index') && ! route().params?.roles"
					id="guidedtour_drawerleft_users_link"
					v-if="isAdmin || isCarrier"
				>
					<q-item-section avatar>
						<q-icon name="people_alt" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Utilisateurs</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Utilisateurs</q-item-label>
					</q-item-section>
					<q-item-section side v-if="!route().current('users.create')">
						<q-btn @click.stop="link(route('users.create'))"
							    icon="person_add_alt" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_users_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('users.index')" />
				</q-item>

	<!-- Driver -->
				<q-item v-if="isAdmin || isCarrier"
                        clickable @click="link(route('users.index')+'?roles='+['driver'])"
                        :active="route().current('users.index') && (route().params?.role == 'driver')">
					<q-item-section avatar>
						<q-icon name="local_shipping" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Chauffeurs</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Chauffeurs</q-item-label>
					</q-item-section>
					<q-item-section side v-if="!route().current('users.create')">
						<q-btn @click.stop="link(route('users.create', {role: 5}))"
							    icon="person_add_alt" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_driver_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('users.index')+'?roles='+['driver']" />
				</q-item>

	<!-- Client -->
				<!-- <q-item v-if="isAdmin"
                        clickable @click="link(route('users.index')+'?roles='+['client'])"
                        :active="route().current('users.index') && (route().params?.roles == 'client')">
					<q-item-section avatar>
						<q-icon name="account_box" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Clients</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Clients</q-item-label>
					</q-item-section>
					<q-item-section side v-if="!route().current('users.create')">
						<q-btn @click.stop="link(route('users.create', {role: 4}))"
							    icon="person_add_alt" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_client_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('users.index')+'?roles='+['client']" />
				</q-item> -->

	<!-- Carrier -->
				<!-- <q-item v-if="isAdmin"
                        clickable @click="link(route('users.index')+'?roles='+['carrier'])"
                        :active="route().current('users.index') && (route().params?.roles == 'carrier')">
					<q-item-section avatar>
						<q-icon name="support_agent" size="md" color="grey" />
                        <q-tooltip v-if="miniDrawer">Transporteurs</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Transporteurs</q-item-label>
					</q-item-section>
					<q-item-section side v-if="!route().current('users.create')">
						<q-btn @click.stop="link(route('users.create', {role: 3}))"
							    icon="person_add_alt" color="green" flat square size="sm"
                                id="guidedtour_drawerleft_carrier_link_add" />
					</q-item-section>
					<OpenInNewTab :router="route('users.index')+'?roles='+['carrier']" />
				</q-item> -->


				<!-- Queues Failed - Retry All -->
				<q-item
					clickable
					@click="queueRetryAll()"
					v-if="
						!isMaster &&
						isAdmin &&
						utils.queue_failed_count &&
						!pp.webmaster_is_connected
					"
				>
					<q-item-section avatar>
						<q-icon name="engineering" color="orange" />
                        <q-tooltip v-if="miniDrawer">Relancer les Travaux d'Arrière Plan</q-tooltip>
					</q-item-section>
					<q-item-section>
						<q-item-label>Relancer les Travaux d'Arrière Plan</q-item-label>
						<q-item-label caption>{{ utils.queue_failed_count }} travaux n'ont pas été exécutés</q-item-label>
					</q-item-section>
				</q-item>



        <!-- Lien vers Site internet -->
				<!-- <q-item clickable @click="open(utils.infos.site_url)">
					<q-item-section avatar>
						<q-icon name="open_in_new" color="grey" />
					</q-item-section>
					<q-item-section>
						<q-item-label>Site Internet {{ utils.infos.societe }}</q-item-label>
						<q-item-label caption>Infos & Documents à télécharger</q-item-label>
					</q-item-section>
				</q-item> -->

				<!-- CONTACT -->
				<!-- /!\ Visible uniquement sur la PreProd ! -->
				<ContactMail v-if="isClient && pp().isPreprod" :tooltip="miniDrawer" />


				<Versioning />
			</q-list>

			<!-- </div>
        </transition> -->
		</q-scroll-area>


		<div class="absolute-bottom q-mt-xl q-px-sm text-grey-8">

            <TermsAndPolicyButtons v-if=" ! miniDrawer" flat color="grey-8" size="xs" />

			<q-separator />

			<a class="float-right q-mt-sm" :href="utils.infos.site_url" target="_blank" rel="noreferer noopener">
                <img :src="utils.infos?.logo" width="32px" height="32px" :alt="app_state().app_name" style="border-radius: 100%; box-shadow: 0 0 10px #121212" />
				<!-- <img src="/images/logo.png" width="42px" class="float-right q-my-xs" :alt="app_state().app_name" /> -->
			</a>

			<!--
            <div v-if=" ! miniDrawer">
				<br />

				<small>Développé par </small>
				<a :href="utils.infos.webmaster_url" target="_blank" rel="noreferer noopener">
					!-- <img src="data:image/png;base64,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" --
					<q-img :src="utils.infos?.appli_url+'/images/wicod-logo_100x20.png'" width="70px" style="margin-bottom: -4px; margin-left: 4px" alt="wicod.fr" />
				</a>
            </div> -->
		</div>
	</q-drawer>


    <RecapMonthly v-if="isAdmin || isCarrier" />

</template>

<script setup>
import { pp, app_state, notify, link, open, formatDate, minutesToHours } from "@helpers";
import { onMounted } from "@vue/runtime-core";
import { ref, computed } from "@vue/reactivity";
import { courseStore } from "@stores";

import RecapMonthly from '@page/Course/partials/RecapMonthly.vue'
import Versioning from "@comp/Versioning.vue";
import ContactMail from "@comp/ContactMail.vue";
import TermsAndPolicyButtons from "@comp/TermsAndPolicyButtons.vue";
import WebmasterActions from "@comp/WebmasterActions.vue";


let c_state = courseStore().$state

let size_recapMonthlyResult = computed(()=> _.size(c_state.recapMonthlyResult) )


let miniDrawer = ref(false)

onMounted(() => {
	if (proto.$_hasTouch) {
		app_state().openDrawerLeft = false;
	}
});

const queueRetryAll = () => {
	$q.dialog({
		title: "Relancer les Travaux d'Arrière Plan ?",
		ok: true,
		cancel: true,
		html: true,
		message: `<p><b>${
			pp().utils.queue_failed_count
		} Travaux d'Arrière Plan</b> ne se sont pas exécutés correctement, pour diverses raisons...</p>
                                        <p><ul><li>Trop a faire d'un coup</li><li>Nombre d'Éssais maximum dépassé</li><li>Erreur</li><li>...</li></ul></p>
                                        <p>Vérifiez aussi si vous êtes le seul Administrateur connecté avant de lancer l'action (un autre Admin l'a peut-être déjà lancée...)</em><br/>(pour cela, le plus sûr est de changer de page et aller voir dans les "Sessions en cours")</p>
                                        <p><b>Si il en reste encore après cette action. Ne recommencez pas; il y a peut-être une erreur.</b><br/>À ce moment là, contactez ${
											pp().utils.infos.webmaster_name
										}.</p>`,
	}).onOk(() => {
		link(route("app-queue-retry-all"));

		notify("info", "Ré-exécutions des Travaux Dispatchés");
	});
};
//     }
// }
</script>
